import loadable from '@loadable/component';

const ProductsPage = loadable(() => import('./page'));
const ProductDashboardPage = loadable(() => import('./[id]/page'));

export const routes = [
  {
    path: '',
    element: <ProductsPage />,
  },
  {
    path: ':id',
    element: <ProductDashboardPage />,
  },
];
